import { Component, OnInit, Optional, Inject, ViewChild, ElementRef, ChangeDetectorRef, ViewEncapsulation } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import{MatChipInputEvent} from '@angular/material/chips';
import { MatOption } from '@angular/material/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { MatAutocompleteSelectedEvent, MatAutocomplete } from '@angular/material/autocomplete';
import { UserService } from 'src/app/services/user.service';
import { UserRoles } from '../../../enums/userRoles.enum';
import { OrganizationService } from 'src/app/services/Organization/organization.service';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';
import { AuthServiceService } from 'src/app/services/auth-service.service';
import { InfoDialogComponent } from 'src/app/components/info-dialog/info-dialog.component';
import { Location } from '@angular/common';
import { EmployeeService } from '../../employee-profile/employee-profile.service';
import { SharedSkillService } from '../../skill-repository/shared-skill.service';
import { data, event } from 'jquery';
import { ToastrService } from "ngx-toastr";


declare var $: any;

@Component({
  selector: 'app-user',
  templateUrl: './user.component.html',
  styleUrls: ['./user.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class UserComponent implements OnInit {
  public roles = [];
  public loading = false;
  public organizations: any[] = [];
  public organizationTags = [];
  public organizationName = '';
  public role: string;
  public visible = true;
  public selectable = true;
  public removable = true;
  public addOnBlur = true;
  public tagsControl = new UntypedFormControl();
  @ViewChild('categoryInput') tagsInput: ElementRef;
  formData = new UntypedFormGroup({
    UserName: new UntypedFormControl('', Validators.required),
    Email: new UntypedFormControl({value:'', disabled: true}, 
    Validators.compose([Validators.required, Validators.pattern(/^[\w-]+(\.[\w-]+)*@([\w-]+\.)+[a-zA-Z]{2,7}$/)])),
    Role: new UntypedFormControl('', Validators.required),
    Organization: new UntypedFormControl('', Validators.required),
    SelectAllOrganizations: new UntypedFormControl(''),
    ViewAllControl: new UntypedFormControl(''),
    downloadAndMail: new UntypedFormControl('')
  });

  tags: Array<any> = [];
  @ViewChild('auto') matAutocomplete: MatAutocomplete;
  @ViewChild('allSelected') private allSelected: MatOption;
  allOrganizationsSelected: boolean;
  // selectAllOrganizations: boolean;
  tagsLoaded: boolean;
  viewAll = false;
  filteredValues: any[] = [];
  employee: any = {};
  filterValues: any[] = [];
  a:any=null;
  users: any;
  flag: any;
  selectedtags: any[];
  organizationId: any;
  savedOrganizationId: any;
  savedOrganization: any[];
  orgs:Array<any>=[];
  employeeId : string;
  constructor(@Optional() public dialogRef: MatDialogRef<UserComponent>, private employeeService: EmployeeService,
  public sharedSkillService: SharedSkillService,  
  private toastr: ToastrService,
  private cd: ChangeDetectorRef, private auth: AuthServiceService,
    // tslint:disable-next-line: max-line-length
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    private location: Location,
    private matDialog: MatDialog, private userService: UserService, private organizationService: OrganizationService) { }

  ngOnInit() {
    this.role = this.auth.getRole();
    this.fetchAllUsers();  
    this.checks();
    this.selected(event);
    if (this.data && this.data.user) {
      this.formData.patchValue({
        UserName: this.data.user.userName,
        Email: this.data.user.userEmail,
        Role: this.data.user.userRole,
        downloadAndMail: !this.data.user.mailAndDownloadAccess,
        Organization: this.data.user && this.data.user.organizationId ? this.data.user.organizationId : '',
        // set orgId here
      });
      this.employeeId = this.data.user.employeeId;
      this.organizationName = this.data.user && this.data.user.organizationName ? this.data.user.organizationName : '';
      this.fetchOrganizations(true);
    } else {
      this.fetchOrganizations();
    }
    // this.roles = Object.values(UserRoles);

    for (const [key, value] of Object.entries(UserRoles)) {
      if (!Number.isNaN(Number(key))) {
        continue;
      }

      this.roles.push({ id: value, name: key });
    }

    if (this.role.indexOf(UserRoles.Admin)>=0) {
      const index = this.roles.indexOf(x => x.id === UserRoles.SuperAdmin);
      this.roles.splice(index, 1);
      this.formData.patchValue({
        // tslint:disable-next-line: max-line-length
        Organization: this.data.user && this.data.user.organizationId ? this.data.user.organizationId : this.auth.getOrganizationId()
      });
    }
  }

  fetchAllUsers() {
    this.loading = true;
    this.userService.fetchUsersList().subscribe(res => {
      this.loading = false;
      this.users = res;
    }, err => {
      this.loading = false;
    });
  }

  fetchOrganizations(initial?) {
    this.organizationService.fetchOrganizationsList().subscribe(res => {
      this.organizations = res;
      this.getOrganizationTags(initial, false);
    });
    
  }

  getFilteredValues(event: any) {
    this.employeeService.getEmployeesOnSearch(event).subscribe((res) => {
      this.filteredValues = res.data ? res.data.profiles : [];
    });
  }
  getFilteredValue(event: any) {
    this.employeeService.getEmployeesOnSearch(event).subscribe((res) => {
      this.filterValues = res.data ? res.data.profiles : [];
    });
  }
  setCurrentEmployee(value: any) {
    this.employee = {}
    this.sharedSkillService.setEmployeeId(value);
    this.getEmployeeDetalis(value)
  }
  setUserEmail(employeeId : any){
    this.formData.controls.Email.setValue(this.filteredValues.find(x=>x.employeeId === employeeId)?.emailAddress);
  }
  Onchange()
  {
    if(this.flag)
    this.a=this.formData.value
  }
  getEmployeeDetalis(empId?: string) {
    if (!empId)
      empId = this.sharedSkillService.getEmployeeId()
    
    if (empId) {
      this.loading = true;
      this.employeeService.getEmployeeDetails(empId).subscribe(res => {
        res.data.competencies?.forEach(c=>{
          c.subCompetencies?.forEach(s=>{
            s.certificates?.forEach(sc=>{
              if(sc.status == 2){
                sc.status = 1;
                sc.plannedDate = sc.expiryDate;
                sc.expiryDate = null;
              }
              return sc
            })
            return s
          })
          return c
        });
        this.employee = res.data;
        this.loading = false;
        //this.primarySkillDropdown()
        // this.selectedCompetencies = this.employee.competencies
        // this.currentCompetency = this.selectedCompetencies ? this.selectedCompetencies[0] : {}
        // this.selectedCertifications = this.currentCompetency && this.currentCompetency.certifications ? this.currentCompetency.certifications : []
        // this.selectedPrimarySkills = this.currentCompetency && this.currentCompetency.primarySkills ? this.currentCompetency.primarySkills : []
        // this.selectedSecondarySkills = this.currentCompetency && this.currentCompetency.secondarySkills ? this.currentCompetency.secondarySkills : []
        // this.selectCompetency(this.currentCompetency.id)
      }, error => {
        this.loading = false;
      });
    }
  }
  
  checkForDuplicate(value) {
    if (value && this.data && this.data.title === 'Update User') {
      const index = this.users.findIndex(ele => ele.userEmail.toLowerCase() === value.toLowerCase());
      if (index >= 0) {
        this.formData.controls.Email.setErrors({ duplicate: true });
      } else {
        this.formData.controls.Email.setErrors(null);
      }
    }
    else if (value && this.data.title !== 'Update User') {
      const index = this.users.findIndex(ele => ele.userEmail.toLowerCase() === value.toLowerCase());
      if (index >= 0) {
        this.formData.controls.Email.setErrors({ duplicate: true });
      } else {
        this.formData.controls.Email.setErrors(null);
      }
    }
  }

  checked(event) {
    if (event.checked) {
      this.organizationTags.forEach(elem => {
        this.tags.push(elem);
      });
      this.organizationTags = [];
      this.allOrganizationsSelected = true;
      
    } else {
      this.allOrganizationsSelected = false;
    }
  }
  
  checkSuperAdmin()
  {
  
    return this.role.indexOf('CaseStudies.SuperAdmin')>=0 || this.role.indexOf('CaseStudies.Admin')>=0
  }
  cancel() {
    this.dialogRef.close({ data: 'no' });
  }
  updateRole(event) {
    if (event.value === "CaseStudies.SuperAdmin") {
      this.formData.controls.ViewAllControl.patchValue(true);
      this.viewAll = false;
      //this.toggleAllSelection();
    }
  }

  getOrganizationTags(initial?, isSelectAll?) {
    this.organizationTags = Object.assign(this.organizationTags, this.organizations);
    if (this.data && this.data.user) {
      isSelectAll = this.data.user.organizationTagIds.length === this.organizationTags.length;
      
    }
    if (initial) {
      this.tags = [];
      const initialIndex = this.organizationTags.findIndex(ele => ele.id === this.formData.get('Organization').value);
      if (initialIndex >= 0) {
        this.tags.push(this.organizationTags[initialIndex]);
        this.formData.controls.SelectAllOrganizations.patchValue([this.organizationTags[initialIndex]]);


      }

      if (this.data.user.organizationTagIds && this.data.user.organizationTagIds.length) {
        this.tags = [];
        // tslint:disable-next-line: prefer-for-of
        for (let i = 0; i < this.data.user.organizationTagIds.length; i++) {
          ;
          const index = this.organizationTags.findIndex(ele => ele.name === this.data.user.organizationTagIds[i]);
          if (index >= 0) {
            this.tags.push(this.organizationTags[index]);
          }
        }
      }
      if (isSelectAll) {
        this.viewAll = true;
        this.tags = [];
        this.organizationTags.forEach(elem => {
          this.tags.push(elem);
        });
        this.formData.controls.ViewAllControl.patchValue(true);
      }
      this.formData.controls.SelectAllOrganizations.patchValue(this.tags);
      this.tagsLoaded = true;
      // else {
      //   index = this.tags.findIndex(ele => ele.id === organizationId);
      //   if (index >= 0) {
      //     this.tags.splice(index, 1);
      //   }
      // }

    } else {
      this.tags = this.organizationTags;

    }

  }


  updateOrganizations(event) {
    const info = this.organizations.find(ele => ele.id === event.value);
    const viewOrgs = this.formData.controls.SelectAllOrganizations as UntypedFormControl;
    if (info) {
      this.organizationName = info.name;
      this.organizationId = info.Id;
    }
    // tslint:disable-next-line: triple-equals
    if (!viewOrgs.value || viewOrgs.value.length != this.organizationTags.length) {
      viewOrgs.patchValue([info]);
      this.tags = [info];
      this.selectedtags=[info];
    }
  }


  onSubmit() {
    this.flag = true;
    this.loading = true;
    this.a=this.formData.getRawValue()
    
    if (!(this.a.Email&&this.a.UserName&&this.a.Role
      &&this.a.Organization
     
    )) {
       
      return ;
    }
    this.employeeId = this.filteredValues?.filter(x => x.name == this.formData.get('UserName').value)[0]?.employeeId ?
                              this.filteredValues?.filter(x => x.name == this.formData.get('UserName').value)[0].employeeId.toString() : this.employeeId
    const user = {
      UserEmail: this.formData.get('Email').value,
      UserName: this.formData.get('UserName').value,
      UserRole: this.formData.get('Role').value,
      OrganizationId: this.formData.get('Organization').value,
      OrganizationName: this.organizationName,
      IsActive: true,
      CreatedBy: '',
      UpdatedBy: '',
      //mailAndDownloadAccess: true,
      mailAndDownloadAccess: !this.formData.get('downloadAndMail').value,
      OrganizationTagIds: this.tags.map(ele => ele.name),
      employeeId: this.employeeId
    };
    // if (!(this.a.UserName&&this.a.UserEmail&&this.a.UserRole
    //   &&this.a.OrganizationName
    // )) {
        
    //   return ;
    // }
    if (this.role.indexOf('CaseStudies.Admin')>=0 && this.data.title != 'Update User') {
      user.OrganizationName = this.auth.getOrganizationName();
      user.OrganizationTagIds = [this.auth.getOrganizationName()];
    }
    if (this.data && this.data.title === 'Update User') {
      if (this.data.user.id) {
        user['id'] = this.data.user.id;
        user.UpdatedBy = this.auth.getEmailId();
        this.dialogRef.close();
        this.userService.updateUser(user).subscribe(res => {
          this.loading = false;
          if (res) {
            this.toastr.success(' Details Updated Successfully');
          }
          else {
            this.showDialog('User updation failed', true, 'text-danger');
          }

        }, err => {
          this.showDialog('User updation failed', true, 'text-danger');
          this.loading = false;
        });
      }
    } else {
      user.UpdatedBy = this.auth.getEmailId();
      user.CreatedBy = this.auth.getEmailId();
      this.userService.addUser(user).subscribe(res => {
        this.dialogRef.close();
        this.loading = false;
        if (res) {
          this.toastr.success('User Added Successfully');
        }
        else {
          this.toastr.error('User insertion failed');
        }
      }, err => {
        this.fetchAllUsers();
        this.toastr.error('User is Already Existed');
        this.loading = false;
      });
    }

  }

  showDialog(message, navigateBack?, font?) {
    this.matDialog.open(InfoDialogComponent, {
      width: '280px',
      data: { message: message, class: font ? font : 'text-danger' }
    }).afterClosed().subscribe(res => {
    });
  }
  dismissSidebar() {
    $('#sidebar').removeClass('active');
    $('#sidebar_r').removeClass('active');
    $('.overlay').removeClass('active');
  }
  ischecked=false;
  checks():void
  {
    this.organizationService.fetchOrganizationsList().subscribe(res => {
      this.organizations = res;    
    if(res.length=== this.data.user.organizationTagIds.length)
    {
      this.ischecked= true;
    }
  })
  }
  selectAll(event):void
  { 
    let selectedOrganizationTags=this.selectedtags;
    this.savedOrganizationId=this.formData.get('Organization').value;
    this.savedOrganization=this.organizationTags.filter(x=>x.id==this.savedOrganizationId);
    if(event.checked)
    {
    this.orgs = this.organizationTags.map(organization => organization);
    this.tags=this.organizationTags.map(organization => organization);
    
    }
    else{
      this.orgs=selectedOrganizationTags; 
      this.tags=selectedOrganizationTags;
      if(this.data.title=='Update User')
      {
        this.tags=this.savedOrganization;
        this.orgs=this.savedOrganization;
      }
      
    }
  }
  selected(event): void {
    if (event.value && event.value.length) {
      if (event.value.includes('selectAll')) {
        this.tags = this.organizationTags.map(organization => organization);
        //this.formData.controls.ViewAllControl.patchValue(true);
        this.viewAll = true;
      }else {
        this.tags = event.value;
        if (event.value.length === this.organizationTags.length) {
         // this.formData.controls.ViewAllControl.patchValue(true);
          this.viewAll = true;
        } else {
          //this.formData.controls.ViewAllControl.patchValue(false);
          this.viewAll = false;
        }
      }
    }
  }
  
  // selected(event): void {

  //           this.tags = event.value;
  //           if (event.value && event.value.length) {
  //             if (event.value.length === this.organizationTags.length) {
  //               this.formData.controls.ViewAllControl.patchValue(true);
  //               this.viewAll = true;
  //             } else {
  //               this.formData.controls.ViewAllControl.patchValue(false);
  //               this.viewAll = false;
  //             }
  //           }
  //         }

  trackByIndex(index, item) {
    return index;
  }

  add(event: MatChipInputEvent): void {
    if (!this.matAutocomplete.isOpen) {
      const input = event.input;
      const value = event.value;
      if ((value || '').trim()) {
        if (this.organizationTags.find(elem => elem.name === value.toLowerCase().trim())) {
          this.tags.push(value.trim());
        }
      }
      if (input) {
        input.value = '';
      }
      this.tagsControl.setValue(null);
    }
  }

  toggleAllSelection() {

    if (this.viewAll) {
      // Find an organizationId and assign to Select All Organizations and toggle the select All checkbox with ViewAll flag.
      const Orgs = this.organizations.find(ele => ele.id === this.formData.get('Organization').value);
      this.formData.controls.SelectAllOrganizations.patchValue([Orgs]);
      this.tags = [Orgs];
      this.viewAll = false;
    } else {

      // Assign all organizations to Select All Organizations and toggle the select All checkbox with ViewAll flag.

      this.formData.controls.SelectAllOrganizations.patchValue([...this.organizationTags]);
      this.viewAll = true;
      this.tags = this.organizationTags;
      // this.organizationTags.forEach(elem => {
      //   this.tags.push(elem);
      // });
    }
  }


}
